import { useState, useEffect } from 'react';

import throttle from 'lodash/throttle';

export interface ScrollProps {
  /** The distance between the top of the page and current element. */
  currentScrollTop: number;
  /** Has the user scrolled down. */
  hasScrolledDown: boolean;
  /** Has the user scrolled up */
  hasScrolledUp: boolean;
  previousScrollTop: number;
}

const useScrollCallback = (callback: (props: ScrollProps) => void, throttleInterval = 250) => {
  const [, setScrollPosition] = useState(0);
  let previousScrollTop = 0;

  const handleScroll = () => {
    const { scrollTop: currentScrollTop } = document.documentElement || document.body;

    setScrollPosition(previousPosition => {
      previousScrollTop = previousPosition;
      return currentScrollTop;
    });

    const hasScrolledDown =  previousScrollTop < currentScrollTop;
    const hasScrolledUp =  previousScrollTop > currentScrollTop;

    callback({
      currentScrollTop,
      hasScrolledDown,
      hasScrolledUp,
      previousScrollTop
    });
  };

  const handleScrollThrottled = throttle(handleScroll, throttleInterval);

  useEffect(() => {
    window.addEventListener('scroll', handleScrollThrottled);
    return () => window.removeEventListener('scroll', handleScrollThrottled);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useScrollCallback;
